/**
 * RESPONSIBILITY: one button under a section of the Visit page.
 */
import { Row, Text, Link } from '@framework/core/decorators';
import { LINK_HINT } from '../../hints';

@Row()
export class VisitButton {
  @Text({ label: 'Button text', maxLength: 120, description: 'e.g. Plan a visit, Get directions.' })
  label!: string;

  @Link({ label: 'Button link', description: LINK_HINT })
  href!: string;
}
